import { atom } from 'jotai';
import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';

const intervalAtom = atom<{ from: string; to: string }>({
  from: moment().subtract(7, 'd').format('YYYY-MM-DD HH:mm:ss'),
  to: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  shortcut: DATE_SHORTCUTS.past7Days,
});

export default intervalAtom;
